import { request } from './client';
import { PUBLIC_API_PATH } from 'config';
import { DEMO_CATALOG } from './catalog';

/**
 * GET /api/commerce/v1/public/store -> store profile `value`.
 * In demo mode the bundled demo shop profile is used and no server is needed.
 */
export async function fetchStoreProfile(options = {}) {
  if (DEMO_CATALOG) {
    const { DEMO_STORE } = await import('demo/store');
    return DEMO_STORE;
  }
  const { value } = await request({ method: 'get', url: `${PUBLIC_API_PATH}/store`, ...options });
  return value;
}
